var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.HoverPopover = function (superClass) {
  extend(HoverPopover, superClass);
  function HoverPopover() {
    return HoverPopover.__super__.constructor.apply(this, arguments);
  }
  HoverPopover.prototype.initialize = function (options) {
    if (this.$el.data('bs.popover')) {
      return;
    }
    this.on_shown = options.on_shown;
    this.show_delay = options.show_delay;
    this.hide_delay = options.hide_delay;
    this.before_show = options.before_show;
    this.frozen = false;
    options.trigger = 'manual';
    this.$el.popover(options);
    if (this._popover_el()) {
      return this._popover_el().on('mouseenter', function (_this) {
        return function () {
          return _this._unschedule_close();
        };
      }(this)).on('mouseleave', function (_this) {
        return function () {
          return _this._schedule_close();
        };
      }(this));
    }
  };
  HoverPopover.prototype.events = {
    'mouseenter': '_schedule_open',
    'mouseleave': '_schedule_close',
    'click': '_handle_click',
    'shown.bs.popover': '_emit_shown'
  };
  HoverPopover.prototype.freeze = function () {
    this._unschedule_open();
    this._unschedule_close();
    return this.frozen = true;
  };
  HoverPopover.prototype.unfreeze = function () {
    this.frozen = false;
    if (this.$el.is(':hover') || this._popover_el().is(':hover')) {
      return this._schedule_open();
    } else {
      return this._schedule_close();
    }
  };
  HoverPopover.prototype._emit_shown = function () {
    if (this.on_shown != null) {
      return this.on_shown(this._popover_el());
    }
  };
  HoverPopover.prototype._handle_click = function (e) {
    e.stopPropagation();
    if (!this.popover_shown) {
      this._show();
      return e.preventDefault();
    }
  };
  HoverPopover.prototype._schedule_open = function (e) {
    if (this.frozen || $a.isLeftMouseButtonDown(e)) {
      return;
    }
    this._unschedule_close();
    return this.openme = setTimeout(function (_this) {
      return function () {
        if (!_this.popover_shown) {
          return _this._show();
        }
      };
    }(this), this.show_delay);
  };
  HoverPopover.prototype._unschedule_open = function () {
    if (this.openme != null) {
      return clearTimeout(this.openme);
    }
  };
  HoverPopover.prototype._schedule_close = function () {
    if (this.frozen) {
      return;
    }
    this._unschedule_open();
    return this.closeme = setTimeout(function (_this) {
      return function () {
        return _this._hide();
      };
    }(this), this.hide_delay);
  };
  HoverPopover.prototype._unschedule_close = function () {
    if (this.closeme != null) {
      return clearTimeout(this.closeme);
    }
  };
  HoverPopover.prototype._show = function () {
    var show_popover;
    show_popover = function (_this) {
      return function () {
        _this.popover_shown = true;
        _this.$el.popover('show');
        return _.defer(function () {
          if (_this.popover_shown) {
            return _this._hide_on_clicking_elsewhere();
          }
        });
      };
    }(this);
    if (this.before_show) {
      return this.before_show(show_popover);
    } else {
      return show_popover();
    }
  };
  HoverPopover.prototype._hide_on_clicking_elsewhere = function () {
    return $(document).on('click.hover-popover', function (_this) {
      return function (e) {
        if (!_this._popover_el()) {
          return;
        }
        if (!(_this._popover_el().has($(e.target)).length > 0)) {
          return _.defer(function () {
            if (_this.popover_shown) {
              return _this._hide();
            }
          });
        }
      };
    }(this));
  };
  HoverPopover.prototype._hide = function () {
    this.popover_shown = false;
    this.frozen = false;
    this.$el.popover('hide');
    return $(document).off('click.hover-popover');
  };
  HoverPopover.prototype._popover_el = function () {
    var ref;
    return (ref = this.$el.data('bs.popover')) != null ? ref.tip() : void 0;
  };
  HoverPopover.prototype.remove = function () {
    this._hide();
    return HoverPopover.__super__.remove.apply(this, arguments);
  };
  _;
  return HoverPopover;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;